const songList = [
  { name: 'Alarm-clock', path: '/songs/alarm_clock.mp3' },
  { name: 'Alarm not loud', path: '/songs/alarm_not_too_loud.mp3' },
  { name: 'Beat', path: '/songs/beat-alarm.mp3' },
  { name: 'Guitar', path: '/songs/guitar_alarm.mp3' },
  {
    name: 'Dickory dock',
    path: '/songs/hickory_dickory_dock-notification.mp3',
  },
  { name: 'Electro', path: '/songs/pruzhina_electro.mp3' },
  { name: 'Samsung', path: '/songs/samsung_s1.mp3' },
  { name: 'Shorty', path: '/songs/shorty.mp3' },
  { name: 'ZvukBudilnika', path: '/songs/zvuk_budilnika.mp3' },
]

export default songList
